(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../enums/metricFormatTypes.js'),
            require('../../../enums/metrics.js').dataType,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.ListeningQuerySearch = exportFn(
                RivalIQ.metrics.new.enums.MetricFormatTypes,
                RivalIQ.enums.dataType,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(MetricFormatTypes, dataType, DataSourceFilterGroupIds) {
        return {

            channelName: 'ListeningQuerySearch',

            storageDimensions: [
            ],

            // NOTE you get at most one of these dimensions; no dimension gets you a summary metric value
            availableDimensions: [

                'listeningQueryId',

                // time series metrics
                'hour',
                'day',
                'week',
                'month',

                // posts
                'post',

                // category top N
                'author',
                'brand',
                'dislike',
                'domain',
                'gender',
                'geolocation',
                'language',
                'like',
                'negativeBehavior',
                'negativeEmotion',
                'person',
                'phrase',
                'positiveBehavior',
                'positiveEmotion',
                'hashtag',
                'sentiment',
                'source'
                // 'things', // NOTE not implemented, as the insights API doesn't allow dimension row filtering by this currently

            ],

            fields: {
                authorDomain: {
                    dataType: dataType.STRING,
                    name: 'Domain'
                },
                authorHandle: {
                    dataType: dataType.STRING,
                    name: 'Handle'
                },
                authorName: {
                    dataType: dataType.STRING,
                    name: 'Author'
                },
                authors: {
                    dataType: dataType.INTEGER,
                    name: 'Authors'
                },
                count: {
                    dataType: dataType.INTEGER,
                    name: 'Posts'
                },
                estimatedCountBelowThreshold: {
                    name: 'Search is below threshold'
                },
                engagementTotal: {
                    dataType: dataType.INTEGER,
                    name: 'Engagement Total'
                },
                geoIsoName: {
                    dataType: dataType.STRING
                },
                geoType: {
                    dataType: dataType.STRING
                },
                impressions: {
                    dataType: dataType.INTEGER,
                    name: 'Potential Impressions'
                },
                name: {
                    dataType: dataType.STRING,
                    name: 'Saved Topic'
                },
                negativeSentiment: {
                    dataType: dataType.INTEGER
                },
                netSentiment: {
                    dataType: dataType.ABSOLUTE_PERCENT,
                    name: 'Net Sentiment',
                    formatOptions: {
                        [MetricFormatTypes.abbreviated]: {
                            maximumFractionDigits: 0
                        },
                        [MetricFormatTypes.expanded]: {
                            maximumFractionDigits: 0
                        }
                    }
                },
                passion: {
                    dataType: dataType.NUMERIC
                },
                positiveSentiment: {
                    dataType: dataType.INTEGER
                },
                postId: {
                    dataType: dataType.STRING
                },
                postAuthorName: {
                    dataType: dataType.STRING,
                    name: 'Author'
                },
                postAuthorUsername: {
                    dataType: dataType.STRING,
                    name: 'Handle'
                },
                postForumName: {
                    dataType: dataType.STRING,
                    name: 'Forum Name'
                },
                postAuthorLink: {
                    dataType: dataType.STRING,
                    name: 'Author Link'
                },
                postDomain: {
                    dataType: dataType.STRING,
                    name: 'Post Domain'
                },
                postAuthorAvatarUrl: {
                    dataType: dataType.STRING,
                    name: 'Avatar Url'
                },
                postPublishedAt: {
                    dataType: dataType.DATE,
                    name: 'Published At'
                },
                postSource: {
                    dataType: dataType.STRING,
                    name: 'Source'
                },
                postTitle: {
                    dataType: dataType.STRING
                },
                postUrl: {
                    dataType: dataType.STRING,
                    name: 'Post Url'
                },
                postDigest: {
                    dataType: dataType.STRING,
                    name: 'Post'
                },
                postEngagements: {
                    dataType: dataType.INTEGER,
                    name: 'Engagement Total'
                },
                postImpressions: {
                    dataType: dataType.INTEGER,
                    name: 'Potential Impressions'
                },
                postSentiment: {
                    dataType: dataType.STRING,
                    name: 'Sentiment'
                },
                postDeleted: {
                    dataType: dataType.BOOLEAN,
                    name: 'Deleted'
                }
                // NOTE there are many more post fields we can add if needed
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.listening,
                DataSourceFilterGroupIds.timePeriod,
                DataSourceFilterGroupIds.ordering
            ]
        };
    }
})();
